/**
 * Typo align
 */
export var Justifiable;
(function (Justifiable) {
    Justifiable["JUSTIFIED_CENTER"] = "JUSTIFIED_CENTER";
    Justifiable["JUSTIFIED_START"] = "JUSTIFIED_START";
    Justifiable["JUSTIFIED_END"] = "JUSTIFIED_END";
    Justifiable["SPACE_BETWEEN"] = "SPACE_BETWEEN";
})(Justifiable || (Justifiable = {}));
/**
 * Returns justifyContent style depending on justify type
 * @param justifyContent {Justifiable|string} - justify type
 * @returns {string} - Justify value
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export var getJustifyStyle = function (justifyContent) {
    switch (justifyContent) {
        case 'JUSTIFIED_CENTER':
            return 'center';
        case 'JUSTIFIED_START':
            return 'flex-start';
        case 'JUSTIFIED_END':
            return 'flex-end';
        case 'SPACE_BETWEEN':
            return 'space-between';
        default:
            return 'flex-start';
    }
};
export var getJustifyClassName = function (justifyContent) {
    switch (justifyContent) {
        case 'JUSTIFIED_CENTER':
            return 'centered';
        case 'JUSTIFIED_START':
            return 'justified-start';
        case 'JUSTIFIED_END':
            return 'justified-end';
        case 'SPACE_BETWEEN':
            return 'spaced-between';
        default:
            return 'justified-start';
    }
};
export var getJustifiedClassName = function (justifyContent) {
    switch (justifyContent) {
        case 'ALIGNED_CENTER':
            return 'justified-center';
        case 'ALIGNED_START':
            return 'justified-start';
        case 'ALIGNED_END':
            return 'justified-end';
        default:
            return 'justified-start';
    }
};
export var getJustifySelfClassName = function (justifyContent) {
    switch (justifyContent) {
        case 'ALIGNED_CENTER':
            return 'justified-self-center';
        case 'ALIGNED_START':
            return 'justified-self-start';
        case 'ALIGNED_END':
            return 'justified-selfend';
        default:
            return 'justified-selfstart';
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSnVzdGlmaWFibGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9vYmplY3RzL2ZhY2V0cy9KdXN0aWZpYWJsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUNILE1BQU0sQ0FBTixJQUFZLFdBS1g7QUFMRCxXQUFZLFdBQVc7SUFDckIsb0RBQXFDLENBQUE7SUFDckMsa0RBQW1DLENBQUE7SUFDbkMsOENBQStCLENBQUE7SUFDL0IsOENBQStCLENBQUE7QUFDakMsQ0FBQyxFQUxXLFdBQVcsS0FBWCxXQUFXLFFBS3RCO0FBUUQ7Ozs7R0FJRztBQUNILDZFQUE2RTtBQUM3RSxNQUFNLENBQUMsSUFBTSxlQUFlLEdBQUcsVUFBQyxjQUF1QjtJQUNyRCxRQUFRLGNBQWMsRUFBRTtRQUN0QixLQUFLLGtCQUFrQjtZQUNyQixPQUFPLFFBQVEsQ0FBQTtRQUNqQixLQUFLLGlCQUFpQjtZQUNwQixPQUFPLFlBQVksQ0FBQTtRQUNyQixLQUFLLGVBQWU7WUFDbEIsT0FBTyxVQUFVLENBQUE7UUFDbkIsS0FBSyxlQUFlO1lBQ2xCLE9BQU8sZUFBZSxDQUFBO1FBQ3hCO1lBQ0UsT0FBTyxZQUFZLENBQUE7S0FDdEI7QUFDSCxDQUFDLENBQUE7QUFFRCxNQUFNLENBQUMsSUFBTSxtQkFBbUIsR0FBRyxVQUFDLGNBQXVCO0lBQ3pELFFBQVEsY0FBYyxFQUFFO1FBQ3RCLEtBQUssa0JBQWtCO1lBQ3JCLE9BQU8sVUFBVSxDQUFBO1FBQ25CLEtBQUssaUJBQWlCO1lBQ3BCLE9BQU8saUJBQWlCLENBQUE7UUFDMUIsS0FBSyxlQUFlO1lBQ2xCLE9BQU8sZUFBZSxDQUFBO1FBQ3hCLEtBQUssZUFBZTtZQUNsQixPQUFPLGdCQUFnQixDQUFBO1FBQ3pCO1lBQ0UsT0FBTyxpQkFBaUIsQ0FBQTtLQUMzQjtBQUNILENBQUMsQ0FBQTtBQUVELE1BQU0sQ0FBQyxJQUFNLHFCQUFxQixHQUFHLFVBQUMsY0FBdUI7SUFDM0QsUUFBUSxjQUFjLEVBQUU7UUFDdEIsS0FBSyxnQkFBZ0I7WUFDbkIsT0FBTyxrQkFBa0IsQ0FBQTtRQUMzQixLQUFLLGVBQWU7WUFDbEIsT0FBTyxpQkFBaUIsQ0FBQTtRQUMxQixLQUFLLGFBQWE7WUFDaEIsT0FBTyxlQUFlLENBQUE7UUFDeEI7WUFDRSxPQUFPLGlCQUFpQixDQUFBO0tBQzNCO0FBQ0gsQ0FBQyxDQUFBO0FBRUQsTUFBTSxDQUFDLElBQU0sdUJBQXVCLEdBQUcsVUFBQyxjQUF1QjtJQUM3RCxRQUFRLGNBQWMsRUFBRTtRQUN0QixLQUFLLGdCQUFnQjtZQUNuQixPQUFPLHVCQUF1QixDQUFBO1FBQ2hDLEtBQUssZUFBZTtZQUNsQixPQUFPLHNCQUFzQixDQUFBO1FBQy9CLEtBQUssYUFBYTtZQUNoQixPQUFPLG1CQUFtQixDQUFBO1FBQzVCO1lBQ0UsT0FBTyxxQkFBcUIsQ0FBQTtLQUMvQjtBQUNILENBQUMsQ0FBQSJ9